
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api/oauth",
      function () {
        return require("private-next-pages/docs/api/oauth.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api/oauth"])
      });
    }
  